import React from 'react';
import PropTypes from 'prop-types';

import SelectionBox from './SelectionBox';
import { getSelectableRowKeys, callOrReturn } from './utils';

class SelectionCell extends React.PureComponent {
  constructor(props) {
    super(props);

    this._handleChange = this._handleChange.bind(this);
  }

  render() {
    const {
      rowData,
      rowIndex,
      data,
      selectable,
      selectionBoxProps,
      showDisabledSelection,
      selectedRowKeys,
      rowKey
    } = this.props;
    // frozen rows
    if (rowIndex < 0) return null;

    const selectableRowKeys = getSelectableRowKeys(data, selectable, rowKey);
    const key = rowData[rowKey];
    const disabled = !selectableRowKeys.includes(key);
    if (disabled && !showDisabledSelection) return null;

    const checked = selectedRowKeys.includes(key);
    const extraProps = callOrReturn(selectionBoxProps, { rowData, rowIndex, disabled, checked });

    return (
      <SelectionBox
        disabled={disabled}
        checked={selectedRowKeys.includes(key)}
        {...extraProps}
        onChange={this._handleChange}
      />
    );
  }

  _handleChange(selected) {
    const { rowData, rowIndex } = this.props;
    this.props.onChange({ selected, rowData, rowIndex });
  }
}

SelectionCell.propTypes = {
  rowData: PropTypes.object,
  rowIndex: PropTypes.number,
  data: PropTypes.arrayOf(PropTypes.object),
  rowKey: PropTypes.string,
  selectable: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  selectionBoxProps: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  showDisabledSelection: PropTypes.bool,
  selectedRowKeys: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func
};

export default SelectionCell;
